module.exports = __webpack_public_path__ + "img/LDA_Technologies_Logo.8c9b5c14.jpg";